import { render, staticRenderFns } from "./stackedAreaChart.vue?vue&type=template&id=218af556&scoped=true"
import script from "./stackedAreaChart.vue?vue&type=script&lang=js"
export * from "./stackedAreaChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218af556",
  null
  
)

export default component.exports